<template>
    <div>
        <header-analytics
            v-if="groupingEntitySingle"
            :headerAnalyticsItems="headerAnalyticsItems"
            :isCreateSlice="isCreateSlice"
            @onCreateSlice="onCreateSlice"
            :showExport="taskMessage === '' && !taskId"
            @onClickExportPlacements="exportPlacements"
            @onClickExportPlacementsNew="exportPlacementsNew"
            @onClickExportTable="exportTable"
            @onClickExportTableDetail="exportTableDetail"
            @onClickExportMedia="exportTableMedia"
            @onClickExportSupplierReport="onExportSupplierReport"
        />
        <message
            v-if="taskMessage !== ''"
            :text="taskMessage"
            :styleClass="{
                color: '#fff',
                background: '#3CB371',
                padding: '5px 0 5px 20px',
                margin: '5px 0 5px 0',
                'border-radius': '10px'
            }"
        />
    </div>
</template>

<script>
import {mapState} from 'vuex';
import HeaderAnalytics from '../../components/Headers/HeaderAnalytics/HeaderAnalytics';
import serviceAuth from '../../services/serviceAuth';
import serviceApi from '../../services/serviceApi';
import schemeAnalytics from '../../schemes/schemeAnalytics';
import schemeApi from '../../schemes/schemeApi';
import mixinAnalytics from "../../mixins/mixinAnalytics";
import Message from "../../components/Base/Message";
import mixinGroupingEntity from "@/mixins/mixinGroupingEntity";
import {utilsBase64} from '../../utils/utilsBase64';
let {headerAnalyticsItems} = schemeAnalytics;
let {
    routeCreateSlice,
    routeExportClients,
    routeExportMedia,
    routeExportSupplierReport,
    routeExportClientsDetail,
    routeExportPlacementsTask,
  routeExportPlacementsTaskNew,
    routeExportCheckTask
} = schemeApi;
export default {
    name: 'ViewAnalyticsHeader',
    mixins: [
        mixinAnalytics,
        mixinGroupingEntity
    ],
    components: {
        HeaderAnalytics,
        Message
    },
    /**
     * данные компонента
     * @property {array} headerAnalyticsItems - элементы хэдера
     * @property {string} taskMessage - ответ таск менеджера
     * @property {number} taskId - id задачи
     * @property {number} timerId - таймер
     */
    data: () => ({
        // headerAnalyticsItems: headerAnalyticsItems,
        taskMessage: '',
        taskId: null,
        timerId: null,
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         * @property {Object} filterSelected - выбранное в фильтре
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId,
            filterSelected: state => state.filterSelected
        }),
        /**
         * тело запроса
         * @returns {object}
         */
        reqBodyGetDataClients() {
            let reqBody = {
                filter_params: this.filterSelected
            }
            return reqBody;
        },
        isCreateSlice() {
            return serviceAuth.checkPermission(this.activeProjectId, "make_slice");
        },
        headerAnalyticsItems(){
          let items = [...headerAnalyticsItems];
          let clientsIndex = items.findIndex((item) => item.route === '/analytics/clients');
          const itemNew = {...items[clientsIndex], name: this.groupingEntityMulti};
          let clientsConditionIndex = items.findIndex((item) => item.route === '/analytics/client-condition');
          const itemConditionNew = {...items[clientsConditionIndex], name: this.groupingEntitySingle ? this.groupingEntitySingle + " условия" : ""};
          items.splice(clientsIndex, 1, itemNew);
          items.splice(clientsConditionIndex, 1, itemConditionNew);
          return items;
        }
    },
    mounted() {

    },
    methods: {
        /**
         * создать срез
         * @async
         */
        async onCreateSlice(year) {
            // let isСonfir = confirm('Вы уверены что хотите создать срез');
            // if (isСonfir) {
              try {
                  let {data = {}} = await serviceApi.post(routeCreateSlice, {year: year});
                  let {message = null} = data;
                  if (message !== null)
                      alert(message);
              }
              catch(error) {
                  if (error.message === 'not server')
                      alert('Извините, сервер временно недоступен');
              }
            // }
        },
        async onExportSupplierReport(){
            let route = routeExportSupplierReport;
            let postData = this.reqBodyGetDataClients;
            let {data: {body = null}} = await serviceApi.post(route, postData);
            if(body !== null){
                let blobXlsx = utilsBase64.convertToBlob(body, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                window.open(window.URL.createObjectURL(blobXlsx), "_blank");
            }
        },
        async exportTableMedia(withTax){
          try {
            let postData = this.reqBodyGetDataClients;
            let route = routeExportMedia + "?withTax=" + (withTax ? "1" : "0");
            let {data = {}} = await serviceApi.post(route, postData);
            if(data.path){
              window.open(data.path, '_blank');
            }
          }
          catch(error) {
            if (error.message === 'not server')
              alert('Извините, сервер временно недоступен');
          }
        },
        /**
         * Экспорт эксель
         * @async
         */
        async exportTable(isGroupAgencyEntity = false){
            try {
                let postData = this.reqBodyGetDataClients;
                postData.group_agency_entity = isGroupAgencyEntity;
                let {data = {}} = await serviceApi.post(routeExportClients, postData);
                if(data.path){
                    window.open(data.path, '_blank');
                }
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
        },
      /**
       * Экспорт эксель Отчет о прибылях и убытках, детализация по клиентам и подрядчикам
       * @async
       */
      async exportTableDetail(){
        try {
          let {data = {}} = await serviceApi.post(routeExportClientsDetail, this.reqBodyGetDataClients);
          let {task_id = null, message = ''} = data;
          this.taskMessage = message;
          this.taskId = task_id;
          if (task_id !== null) {
            this.exportCheckTask();
          }
          // if(data.path){
          //   window.open(data.path, '_blank');
          // }
        }
        catch(error) {
          this.taskMessage = ''
          if (error.response.data.message)
            alert(error.response.data.message);
          if (error.message === 'not server')
            alert('Извините, сервер временно недоступен');
        }
      },
      /**
       * Экспорт конструкций эксель по новому шаблону
       * добавить задачу в очередь
       *
       * @async
       */
        async exportPlacementsNew(){
          this.taskMessage = "Пожалуйста, подождите"
          try {
            let result = await serviceApi.post(routeExportPlacementsTaskNew, this.reqBodyGetDataClients);
            let {task_id = null, message = ''} = result.data;
            this.taskMessage = message;
            this.taskId = task_id;
            if (task_id !== null) {
              this.exportCheckTask();
            }

          }
          catch(error) {
            this.taskMessage = ''
            if (error.response.data.message)
              alert(error.response.data.message);
            if (error.message === 'not server')
              alert('Извините, сервер временно недоступен');
          }
        },
        /**
         * Экспорт конструкций эксель
         * добавить задачу в очередь
         *
         * @async
         */
        async exportPlacements(){
            this.taskMessage = "Пожалуйста, подождите"
            try {
                let result = await serviceApi.post(routeExportPlacementsTask, this.reqBodyGetDataClients);
                let {task_id = null, message = ''} = result.data;
                this.taskMessage = message;
                this.taskId = task_id;
                if (task_id !== null) {
                    this.exportCheckTask();
                }

            }
            catch(error) {
                this.taskMessage = ''
                if (error.response.data.message)
                    alert(error.response.data.message);
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
        },
        /**
         * проверить статус задачи
         * @async
         */
        async exportCheckTask() {
            this.timerId = setInterval(async () => {
                try {
                    let result = await serviceApi.post(routeExportCheckTask, {task_id: this.taskId});
                    let {ready = false, message = '', errors = false, path = ''} = result.data;
                    this.taskMessage = message;
                    if (errors !== false) {
                        this.taskMessage = '';
                        clearInterval(this.timerId);
                        alert('Не удалось прикрепить файл');
                    }
                    if(ready === true && path) {
                        clearInterval(this.timerId);
                        this.taskMessage = '';
                        this.taskId = null;
                        window.open(path, '_blank');
                    }
                }
                catch(error) {
                    this.taskMessage = '';
                    clearInterval(this.timerId);
                    if (error.response.data.message)
                        alert(error.response.data.message);
                    if (error.message === 'not server')
                        alert('Извините, сервер временно недоступен');
                }
            }, 30000);
        },
    }
}
</script>